import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

import { StatsService } from 'src/app/api/services';
import {
  NavigationBreadcrumb,
  NavigationBreadcrumbsComponent,
} from '../../common/navigation-breadcrumbs/navigation-breadcrumbs.component';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MatDrawerContainer,
  MatDrawer,
  MatDrawerContent,
} from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
import { UIEventEnum } from 'src/app/utility/amplitude-tracking/tracking.types';
import { TrackingService } from 'src/app/utility/amplitude-tracking/tracking.service';
import { UtilityService } from 'src/app/utility/utility.service';
import { DestroyNotifier } from '../../common/destroy-notifier';
import { takeUntil, delay } from 'rxjs';
@Component({
  selector: 'qa-content-listing',
  templateUrl: './content-listing.component.html',
  styleUrls: ['./content-listing.component.scss'],
  imports: [
    MatIconButton,
    MatIcon,
    NavigationBreadcrumbsComponent,
    MatDrawerContainer,
    MatDrawer,
    MatNavList,
    MatListItem,
    RouterLink,
    RouterLinkActive,
    MatDrawerContent,
    RouterOutlet,
    TranslateModule,
  ],
})
export class ContentListingComponent
  extends DestroyNotifier
  implements OnInit, OnDestroy
{
  @ViewChild('sidenav') sidenav: any;
  navGroups = [];
  showSidebar = true;
  private _mobileQueryListener: () => void;
  mobileQuery: MediaQueryList;

  navigationBreadcrumb: NavigationBreadcrumb = {
    homeUrl: '/cms/dashboard',
    currentPage: null,
    breadcrumbs: [],
  };

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public auth: AuthService,
    private statsService: StatsService,
    private router: Router,
    private trackingService: TrackingService,
    private utilityService: UtilityService,
    private cdr: ChangeDetectorRef
  ) {
    super();
    this.mobileQuery = media.matchMedia('(max-width: 1350px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.toggleSidenav();
        this.showSidebar = router.url.split('/').length === 4 ? true : false;
      }
    });
  }

  ngOnInit() {
    this.getItemCount();
    this.utilityService.onRefresh$
      .pipe(delay(500), takeUntil(this.destroy$))
      .subscribe(() => {
        this.getItemCount();
      });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  toggleSidenav() {
    if (this.sidenav && this.mobileQuery?.matches) {
      this.sidenav.toggle();
    }
  }

  getItemCount() {
    this.statsService.statsControllerGetStats().subscribe((res) => {
      if (res) {
        this.setNavBar(res);
        this.cdr.detectChanges();
      }
    });
  }

  setNavBar(res) {
    this.navGroups = [
      {
        active: () => this.auth.isLoggedIn(),
        expandable: true,
        icon: 'view_list',
        items: [
          {
            label: 'menu.quiz',
            link: 'quizzes',
            disabledTip: 'menu.cantAccess.quiz',
            itemCount: res.num_quizzes,
          },
          {
            label: 'common.label.questions',
            link: 'questions',
            disabledTip: 'menu.cantAccess.questions',
            itemCount: res.num_questions,
          },
          {
            label: 'common.label.flashCardStack',
            link: 'flash-card-stacks',
            disabledTip: 'menu.cantAccess.flashStacks',
            itemCount: res.num_flash_card_stacks,
          },
          {
            label: 'common.label.quizFlashCard',
            link: 'flash-cards',
            disabledTip: 'menu.cantAccess.flashcards',
            itemCount: res.num_flash_cards,
          },
          {
            label: 'menu.comments',
            link: 'comments',
            disabledTip: 'menu.cantAccess.comments',
          },
          {
            label: 'menu.tags',
            link: 'tags',
            disabledTip: 'menu.cantAccess.tags',
          },
        ],
        label: 'menu.allContent',
      },
    ];
  }

  onChangeItem(item) {
    if (item.link === 'comments') {
      this.trackingService.trackEvent({
        event_type: UIEventEnum.COMMENTS_OPENED,
      });
    } else if (item.link === 'tags') {
      this.trackingService.trackEvent({
        event_type: UIEventEnum.TAGS_OPENED,
      });
    }
  }
}
